import localforage from 'localforage'
import { Base64 } from 'js-base64'

export class AuthCache {
	constructor (opts = {name: "JManCache", storeName: "Auth"}) {
		this.db = localforage.createInstance(opts);
	}

	async getJwt () {
		return await this.db.getItem('jwt');
	}

	putJwt (jwt) {
		this.db.setItem('jwt', jwt)
		.then( () => {
			this.setUser(JSON.parse(Base64.decode(jwt.split(".")[1])));
		})
		.catch(err => console.error("DB ERR", err, entity));
	}

	clearJwt () {
		this.db.removeItem('jwt');
	}

	async getUser () {
		return await this.db.getItem('user');
	}

	putUser (user) {
		this.db.setItem('user', user).catch(err => console.error("DB ERR", err, entity));
	}

	clearUser () {
		this.db.removeItem('user');
	}

	iterate (fn) {
		return this.db.iterate(fn);
	}

	async values () {
		let values = [];
		await this.db.iterate( (value) => {
			values.push(value);
		});
		return values;
	}

};



// WEBPACK FOOTER //
// ./src/assets/js/JMan/AuthCache.js